import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ProfileRead } from '../../../shared/profile-read.model';
import { VerticalNaaService } from 'src/app/vertical/naa/shared/vertical-naa.service';
import { NaaProfileType } from 'src/app/vertical/naa/shared/naa-profile-type.model';
import { ProfileTypeManagementCompanyEditComponent } from './profile-type-management-company-edit/profile-type-management-company-edit.component';
import { ProfileTypeOwnerEditComponent } from './profile-type-owner-edit/profile-type-owner-edit.component';
import { ProfileTypePropertyEditComponent } from './profile-type-property-edit/profile-type-property-edit.component';
import { NaaProfileTypeEnum } from './enum/naa-profile-type.enum';

@Component({
  selector: 'wl-naa-profile-type-edit',
  templateUrl: './naa-profile-type-edit.component.html',
  styleUrls: ['./naa-profile-type-edit.component.less'],
    standalone: false
})
export class NaaProfileTypeEditComponent implements OnInit {
  @Input()
  get profile() {
    return this._profile;
  }
  set profile(value: ProfileRead) {
    this._profile = value;
    this.profileChange.emit(this._profile);
  }
  @Output() profileChange: EventEmitter<ProfileRead> = new EventEmitter();

  @ViewChild(ProfileTypeManagementCompanyEditComponent) _managementCompanyComponent: ProfileTypeManagementCompanyEditComponent;
  @ViewChild(ProfileTypeOwnerEditComponent) _ownerComponent: ProfileTypeOwnerEditComponent;
  @ViewChild(ProfileTypePropertyEditComponent) _propertyComponent: ProfileTypePropertyEditComponent;
  profileType = {} as NaaProfileType;
  profileTypeItems: SelectItem[] = [];
  naaProfileTypeEnum = NaaProfileTypeEnum;

  private _profile: ProfileRead;
  constructor(private _verticalNaaService: VerticalNaaService) {
    this.profile = new ProfileRead();
  }

  ngOnInit(): void {
    this._verticalNaaService.getNaaProfileTypes().then((types) => {
      this.profileTypeItems = types.map<SelectItem>((type) => {
        return { label: type.Name, value: type.Id };
      });
    });
  }

  public save(): Promise<number | void>[] {
    return [this._managementCompanyComponent?.save(), this._ownerComponent?.save(), this._propertyComponent?.save()];
  }
}
